var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gridEstablished)?_c('tm-diag-point',{attrs:{"point":_vm.$data.timePoint,"data-label":_vm.label,"data-xy":_vm.xy}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }